module.exports = __webpack_public_path__ + "static/img/bg_mod_water.4c98f011.jpg";